import { defineComponent as _defineComponent } from 'vue'
import { IEventUserChip } from '@/enitites/event'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserChip',
  props: {
    user: null
  },
  setup(__props: any) {



const { getAvatar } = useImage()

return { __sfc: true,getAvatar }
}

})